import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaSearch, FaExternalLinkAlt } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Portfolio.css';

const Portfolio: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const filters = [
    { id: 'all', label: 'Todos' },
    { id: 'manutencao', label: 'Manutenção' },
    { id: 'fabricacao', label: 'Fabricação' },
    { id: 'recondicionamento', label: 'Recondicionamento' }
  ];

  const portfolioItems = [
    {
      id: 1,
      title: 'Centrifuga Industrial Chibrascenter',
      category: 'manutencao',
      image: '/portfolio-1.jpg',
      description: 'Manutenção preventiva e corretiva completa de centrifuga industrial.',
      client: 'Indústria Petroquímica',
      year: '2023'
    },
    {
      id: 2,
      title: 'Decanter Pieralisi Especializado',
      category: 'fabricacao',
      image: '/portfolio-2.jpg',
      description: 'Fabricação de peças especiais para decanter de alta performance.',
      client: 'Indústria Alimentícia',
      year: '2023'
    },
    {
      id: 3,
      title: 'Sistema de Redução Avançado',
      category: 'recondicionamento',
      image: '/portfolio-3.jpg',
      description: 'Recondicionamento completo de sistema de redução com tecnologia avançada.',
      client: 'Indústria Siderúrgica',
      year: '2023'
    },
    {
      id: 4,
      title: 'Roscas Transportadoras Customizadas',
      category: 'fabricacao',
      image: '/portfolio-4.jpg',
      description: 'Fabricação de roscas transportadoras com revestimento especial.',
      client: 'Indústria Mineração',
      year: '2023'
    },
    {
      id: 5,
      title: 'Tambor e Eixos de Precisão',
      category: 'recondicionamento',
      image: '/portfolio-5.jpg',
      description: 'Recondicionamento de tambor e eixos com balanceamento eletrônico.',
      client: 'Indústria Química',
      year: '2023'
    },
    {
      id: 6,
      title: 'Centrifuga Decantadora Completa',
      category: 'manutencao',
      image: '/portfolio-6.jpg',
      description: 'Manutenção completa de centrifuga decantadora com modernização.',
      client: 'Indústria Têxtil',
      year: '2023'
    },
    {
      id: 7,
      title: 'Sistema de Filtros Industriais',
      category: 'fabricacao',
      image: '/portfolio-7.jpg',
      description: 'Fabricação de sistema completo de filtros para indústria química.',
      client: 'Indústria Química',
      year: '2023'
    },
    {
      id: 8,
      title: 'Manutenção Preventiva Avançada',
      category: 'manutencao',
      image: '/portfolio-8.jpg',
      description: 'Programa de manutenção preventiva com monitoramento remoto.',
      client: 'Indústria Alimentícia',
      year: '2023'
    },
    {
      id: 9,
      title: 'Projeto Especializado de Decanters',
      category: 'fabricacao',
      image: '/portfolio-9.jpg',
      description: 'Projeto e fabricação de decanters customizados para aplicação específica.',
      client: 'Indústria Petroquímica',
      year: '2023'
    }
  ];

  const filteredItems = activeFilter === 'all'
    ? portfolioItems
    : portfolioItems.filter(item => item.category === activeFilter);

  return (
    <div className="portfolio-page">
      {/* Hero Section */}
      <section className="page-hero">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} data-aos="fade-up">
              <h1>Nosso Portfolio</h1>
              <p>
                Conheça alguns dos nossos principais trabalhos realizados
                em diversas indústrias do Brasil.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Filters Section */}
      <section className="section filters-section">
        <Container>
          <div className="filters-container" data-aos="fade-up">
            <div className="filters">
              {filters.map((filter) => (
                <button
                  key={filter.id}
                  className={`filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
                  onClick={() => setActiveFilter(filter.id)}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* Portfolio Grid */}
      <section className="section portfolio-grid-section">
        <Container>
          <Row>
            {filteredItems.map((item, index) => (
              <Col lg={4} md={6} key={item.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="portfolio-item">
                  <div className="portfolio-image">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="img-fluid"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = '/portfolio-placeholder.jpg';
                      }}
                    />
                    <div className="portfolio-overlay">
                      <div className="portfolio-actions">
                        <button className="action-btn" title="Ver detalhes">
                          <FaSearch />
                        </button>
                        <button className="action-btn" title="Ver projeto">
                          <FaExternalLinkAlt />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                    <div className="portfolio-meta">
                      <span className="client">
                        <strong>Cliente:</strong> {item.client}
                      </span>
                      <span className="year">
                        <strong>Ano:</strong> {item.year}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Stats Section */}
      <section className="section stats-section">
        <Container>
          <Row>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={100}>
              <div className="stat-card">
                <div className="stat-number">500+</div>
                <div className="stat-label">Projetos Realizados</div>
              </div>
            </Col>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={200}>
              <div className="stat-card">
                <div className="stat-number">50+</div>
                <div className="stat-label">Estados Atendidos</div>
              </div>
            </Col>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={300}>
              <div className="stat-card">
                <div className="stat-number">25+</div>
                <div className="stat-label">Anos de Experiência</div>
              </div>
            </Col>
            <Col lg={3} md={6} data-aos="fade-up" data-aos-delay={400}>
              <div className="stat-card">
                <div className="stat-number">100%</div>
                <div className="stat-label">Satisfação do Cliente</div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8} data-aos="fade-up">
              <h2>Gostou dos nossos trabalhos?</h2>
              <p>
                Entre em contato conosco e descubra como podemos ajudar
                sua empresa com soluções personalizadas.
              </p>
              <div className="cta-buttons">
                <a href="/contato" className="btn btn-primary btn-lg me-3">
                  Solicitar Orçamento
                </a>
                <a href="/servicos" className="btn btn-outline-primary btn-lg">
                  Conhecer Serviços
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Portfolio; 